var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"grid-x grid-padding-x"},[_c('span',{staticClass:"icon cell small-4"},[_c('FontAwesomeIcon',{attrs:{"icon":['far', 'map-marker-alt'],"size":"4x"}})],1),_vm._v(" "),_c('div',{staticClass:"location-data cell small-18"},[_c('h3',[_c('router-link',{attrs:{"to":_vm.url}},[_vm._v("\n        "+_vm._s(_vm.name)+"\n      ")])],1),_vm._v(" "),_c('address',[_vm._v(_vm._s(_vm.fullAddress))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eae7b06","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LocationListItem.vue
// module id = 709
// module chunks = 0